export interface PromptAnalysis {
    message: string;
    scope: ScopePromptAnalysis;
    themes: string[];
}
export interface DocumentsNeededAnalysis {
    message: string;
    documents: string[];
}
export enum ScopePromptAnalysis {
    Interne = "INTERNE",
    Externe = "EXTERNE"
}